export default "__VITE_ASSET__CHtj$iyH__"